<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>呂善安！你看，我在『彰化市公會堂歷史沿革』的展板後面發現了這張紙！</npc>
              <npc :npc-id="0" >我看看⋯⋯『要追回賴和的記憶，呂善安君還要更加努力。接下來請到賴和就讀的彰化第一公學校，不要來錯地方。』</npc>
              <npc :npc-id="1" right>彰化第一公學校？我知道在哪！不就是剛剛南山寺對面的中山國民小學嗎？</npc>
              <npc :npc-id="0" >確實如此，但怪盜說『不要來錯地方』⋯⋯</npc>
              <npc :npc-id="0" >⋯⋯原來如此，是陷阱題啊。</npc>
              <npc :npc-id="1" right>陷阱？</npc>
              <npc :npc-id="0" >賴和先生確實是就讀彰化第一公學校沒錯，但他入學時，公學校本身還沒蓋好，所以他讀公學校不是中山國小！</npc>
              <npc :npc-id="1" right>咦？那是哪裡？</npc>
              <npc :npc-id="0" >那時是暫時以孔廟為公學校。</npc>
              <npc :npc-id="1" right>孔廟嗎？嗯～意外有種跟公學校截然不同的漢學印象呢！</npc>
              <npc :npc-id="0" >嗯，賴和先生在小逸堂受漢學教育，也在公學校受過新式教育，雖然發起了新文學運動，但他並不排斥傳統漢學，甚至一生中做了許多首漢詩。</npc>
              <npc :npc-id="1" right>真意外，我還以為接受了新式教育，肯定會覺得漢學很落後之類的。</npc>
              <npc :npc-id="0" >確實也有這樣的人吧？但賴和先生不是這樣的。比起那個，我有點在意剛才的謎題。</npc>
              <npc :npc-id="1" right>剛才的謎題？</npc>
              <npc :npc-id="0" >之前在小逸堂的謎題，怪盜設下了可怕的陷阱，讓『臺灣文學館』消失了，但公會堂的謎題卻只是單純的謎題⋯⋯到底怪盜設下謎題的原因是什麼？這次甚至沒有東西被偷啊！</npc>
              <npc :npc-id="1" right>對耶！這根本也不是什麼預告信，甚至不是線索！難道留下這些謎題的並不是怪盜？</npc>
              <npc :npc-id="0" >很難說。但這些卡片留下了怪盜的『簽名』，怎麼想都不會無關。</npc>
              <npc :npc-id="1" right>也就是說，就算不是怪盜，肯定也跟怪盜有關嗎？</npc>
              <npc :npc-id="0" >正是如此。</npc>
              <npc :npc-id="1" right>聽起來，就算覺得可疑，我們也得繼續前進了呢。</npc>
              <npc :npc-id="0" >對，我們快去孔廟吧！線索這種東西，可是隨時間過去就會越來越少的喔！</npc>

              <map-link name="孔廟" map-id="cxX3rph9aXxhJbRE7"/>

              <move-to-stage-btn link="前往孔廟">前往孔廟</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage3_1',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第三章 - 1',
      isQuestion: false,
      stageId: 'kon',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
